/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import type { Point } from 'geojson';

export const defaultData = [
  {
    LATITUDE: 47.588294,
    LONGITUDE: -122.034863,
    SOURCE_COUNT: 420,
    STATE_CODE: 'WA',
    ZIP: '98075',
  },
  {
    LATITUDE: 35.883237,
    LONGITUDE: -86.961133,
    SOURCE_COUNT: 1262,
    STATE_CODE: 'TN',
    ZIP: '37064',
  },
  {
    LATITUDE: 33.778829,
    LONGITUDE: -117.326646,
    SOURCE_COUNT: 368,
    STATE_CODE: 'CA',
    ZIP: '92570',
  },
  {
    LATITUDE: 40.218356,
    LONGITUDE: -84.652582,
    SOURCE_COUNT: 53,
    STATE_CODE: 'OH',
    ZIP: '45303',
  },
  {
    LATITUDE: 41.100602,
    LONGITUDE: -85.180709,
    SOURCE_COUNT: 179,
    STATE_CODE: 'IN',
    ZIP: '46808',
  },
  {
    LATITUDE: 39.796571,
    LONGITUDE: -83.816142,
    SOURCE_COUNT: 2,
    STATE_CODE: 'OH',
    ZIP: '45316',
  },
  {
    LATITUDE: 36.111646,
    LONGITUDE: -115.211941,
    SOURCE_COUNT: 544,
    STATE_CODE: 'NV',
    ZIP: '89103',
  },
  {
    LATITUDE: 33.110098,
    LONGITUDE: -87.552052,
    SOURCE_COUNT: 700,
    STATE_CODE: 'AL',
    ZIP: '35405',
  },
  {
    LATITUDE: 40.771522,
    LONGITUDE: -82.53824,
    SOURCE_COUNT: 436,
    STATE_CODE: 'OH',
    ZIP: '44903',
  },
  {
    LATITUDE: 41.39897,
    LONGITUDE: -83.68613,
    SOURCE_COUNT: 396,
    STATE_CODE: 'OH',
    ZIP: '43402',
  },
  {
    LATITUDE: 34.231248,
    LONGITUDE: -118.245509,
    SOURCE_COUNT: 204,
    STATE_CODE: 'CA',
    ZIP: '91214',
  },
  {
    LATITUDE: 40.692911,
    LONGITUDE: -73.856759,
    SOURCE_COUNT: 133,
    STATE_CODE: 'NY',
    ZIP: '11421',
  },
  {
    LATITUDE: 40.58013,
    LONGITUDE: -83.769524,
    SOURCE_COUNT: 56,
    STATE_CODE: 'OH',
    ZIP: '43310',
  },
  {
    LATITUDE: 34.709737,
    LONGITUDE: -86.742356,
    SOURCE_COUNT: 944,
    STATE_CODE: 'AL',
    ZIP: '35758',
  },
  {
    LATITUDE: 34.767581,
    LONGITUDE: -82.221576,
    SOURCE_COUNT: 818,
    STATE_CODE: 'SC',
    ZIP: '29681',
  },
  {
    LATITUDE: 41.451328,
    LONGITUDE: -81.393304,
    SOURCE_COUNT: 335,
    STATE_CODE: 'OH',
    ZIP: '44022',
  },
  {
    LATITUDE: 29.614261,
    LONGITUDE: -95.391041,
    SOURCE_COUNT: 237,
    STATE_CODE: 'TX',
    ZIP: '77047',
  },
  {
    LATITUDE: 38.83447,
    LONGITUDE: -97.641195,
    SOURCE_COUNT: 580,
    STATE_CODE: 'KS',
    ZIP: '67401',
  },
  {
    LATITUDE: 34.931311,
    LONGITUDE: -78.920537,
    SOURCE_COUNT: 1179,
    STATE_CODE: 'NC',
    ZIP: '28306',
  },
  {
    LATITUDE: 39.895188,
    LONGITUDE: -75.040811,
    SOURCE_COUNT: 149,
    STATE_CODE: 'NJ',
    ZIP: '08033',
  },
  {
    LATITUDE: 26.191556,
    LONGITUDE: -81.804294,
    SOURCE_COUNT: 98,
    STATE_CODE: 'FL',
    ZIP: '34103',
  },
  {
    LATITUDE: 40.725647,
    LONGITUDE: -82.52743,
    SOURCE_COUNT: 171,
    STATE_CODE: 'OH',
    ZIP: '44907',
  },
  {
    LATITUDE: 34.941882,
    LONGITUDE: -92.068454,
    SOURCE_COUNT: 717,
    STATE_CODE: 'AR',
    ZIP: '72023',
  },
  {
    LATITUDE: 34.798828,
    LONGITUDE: -91.907652,
    SOURCE_COUNT: 253,
    STATE_CODE: 'AR',
    ZIP: '72086',
  },
  {
    LATITUDE: 36.641254,
    LONGITUDE: -119.904763,
    SOURCE_COUNT: 251,
    STATE_CODE: 'CA',
    ZIP: '93706',
  },
  {
    LATITUDE: 30.265387,
    LONGITUDE: -91.645057,
    SOURCE_COUNT: 413,
    STATE_CODE: 'LA',
    ZIP: '70582',
  },
  {
    LATITUDE: 44.874438,
    LONGITUDE: -93.334673,
    SOURCE_COUNT: 137,
    STATE_CODE: 'MN',
    ZIP: '55435',
  },
  {
    LATITUDE: 41.504386,
    LONGITUDE: -81.554126,
    SOURCE_COUNT: 481,
    STATE_CODE: 'OH',
    ZIP: '44118',
  },
  {
    LATITUDE: 44.590016,
    LONGITUDE: -91.505874,
    SOURCE_COUNT: 59,
    STATE_CODE: 'WI',
    ZIP: '54738',
  },
  {
    LATITUDE: 39.676683,
    LONGITUDE: -83.902802,
    SOURCE_COUNT: 622,
    STATE_CODE: 'OH',
    ZIP: '45385',
  },
  {
    LATITUDE: 25.917628,
    LONGITUDE: -80.396594,
    SOURCE_COUNT: 483,
    STATE_CODE: 'FL',
    ZIP: '33018',
  },
  {
    LATITUDE: 32.380803,
    LONGITUDE: -90.306106,
    SOURCE_COUNT: 540,
    STATE_CODE: 'MS',
    ZIP: '39209',
  },
  {
    LATITUDE: 30.163983,
    LONGITUDE: -97.822647,
    SOURCE_COUNT: 248,
    STATE_CODE: 'TX',
    ZIP: '78748',
  },
  {
    LATITUDE: 42.564518,
    LONGITUDE: -83.068943,
    SOURCE_COUNT: 317,
    STATE_CODE: 'MI',
    ZIP: '48310',
  },
  {
    LATITUDE: 40.395009,
    LONGITUDE: -111.713361,
    SOURCE_COUNT: 1255,
    STATE_CODE: 'UT',
    ZIP: '84062',
  },
  {
    LATITUDE: 37.810102,
    LONGITUDE: -121.91095,
    SOURCE_COUNT: 336,
    STATE_CODE: 'CA',
    ZIP: '94506',
  },
  {
    LATITUDE: 44.276635,
    LONGITUDE: -89.348453,
    SOURCE_COUNT: 36,
    STATE_CODE: 'WI',
    ZIP: '54909',
  },
  {
    LATITUDE: 44.83418,
    LONGITUDE: -91.483057,
    SOURCE_COUNT: 483,
    STATE_CODE: 'WI',
    ZIP: '54703',
  },
];

interface DataProps {
  [key: string]: unknown;
}

export const defaultProcessDataFn = (
  data: Array<DataProps>,
): GeoJSON.FeatureCollection<GeoJSON.Geometry> => {
  return {
    features: data.map(item => {
      return {
        geometry: {
          coordinates: [item.LONGITUDE, item.LATITUDE],
          type: 'Point',
        } as Point,
        properties: {
          quantity: item.SOURCE_COUNT as number,
          stateCode: item.STATE_CODE as string,
          value: item.SOURCE_COUNT as number,
          zip: item.ZIP as string,
        },
        type: 'Feature',
      };
    }),
    type: 'FeatureCollection',
  };
};
